const configCorrection = {
    correction: {
        listLayout: 'CorrectionListDefaultLayout',
        filterLayout: 'CorrectionFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getCorrection',
        listApiParamSet: {
            r_type : 'admin',
            ip: 1,
            sp:10
        },
    },
    detail:{
        writeLayouts: ['CorrectionWriteDefaultLayout'],
        getFunc: 'getCorrection',
        detailApiParamsSet: {
            r_type : 'admin',
            ip: 0,
            opf:1,
            opd:1,
        },
        writeFunc: 'createCorrection',
        writeApiParamSet: {
            r_type:'answer',
        },
        parsingData: {
            title: 'r_title',
            content: 'r_content',
        },
        directUrl: '',
        directType: 'back',
        keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
    update:{
        writeLayouts: ['CorrectionWriteDefaultLayout'],
        getFunc: 'getCorrection',
        detailApiParamsSet: {
            r_type : 'admin',
            ip: 0,
            opf:1,
            opd:1,
        },
        writeFunc: 'updateCorrection',
        writeApiParamSet: {
            r_type:'answer',
        },
        parsingData: {
            title: 'r_title',
            content: 'r_content',
        },
        directUrl: '',
        directType: 'back',
        keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
    reCreate:{
        writeLayouts: ['CorrectionWriteReRequestLayout'],
        getFunc: 'getCorrection',
        detailApiParamsSet: {
            r_type : 'admin',
            ip: 0,
            opf:1,
            opd:1,
        },
        writeFunc: 'createCorrection',
        writeApiParamSet: {
            r_type:'reanswer',
        },
        parsingData: {
            title: 'r_title',
            content: 'r_content',

        },
        directUrl: '',
        directType: 'back',
        keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
    reUpdate:{
        writeLayouts: ['CorrectionWriteReRequestLayout'],
        getFunc: 'getCorrection',
        detailApiParamsSet: {
            r_type : 'admin',
            ip: 0,
            opf:1,
            opd:1,
        },
        writeFunc: 'updateCorrection',
        writeApiParamSet: {
            r_type:'reanswer',
        },
        parsingData: {
            title: 'r_title',
            content: 'r_content',
            r_parent:'parent_id',
        },
        directUrl: '',
        directType: 'back',
        keyName: 'id',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
}

export default {
    methods: {
        returnCorrectionConfig(type) {
            return configCorrection[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        ac: {
            type: 'between',
            classname: 'filterDate'
        },
        //제목
        ti: {
            type: 'query',
            classname: 'searchInput',
        },
        //사용자닉네임
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        //사용자아이디
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        //내용
        co: {
            type: 'query',
            classname: 'searchInput',
        },
        //언어
        la:{
            type: 'match',
            classname: 'langOption',
        },
        st:{
            type: 'match',
            classname: 'filterStatus',
        }

    }
}
